<script setup lang="ts">
import CoreAlert from 'frontcore/presentation/alert/views/CoreAlert.vue'
import { AlertType } from 'frontcore/presentation/alert/domain/types'
import { PORTAL_LEVELS } from 'frontcore/constants/constants'
import { TOASTS_WRAPPER_ELEMENT_ID } from 'frontcore/presentation/alert/domain/constants'
import { useAlertQueueStore } from 'frontcore/presentation/alert/domain/useAlertQueueStore'

const { alertQueue } = useAlertQueueStore()
</script>

<template>
  <portal
    :to="PORTAL_LEVELS.TOASTS"
    :order="1">
    <transition-group
      :id="TOASTS_WRAPPER_ELEMENT_ID"
      name="toast-fade"
      tag="div"
      class="toasts-wrapper tw-flex tw-flex-col-reverse tw-flex-wrap tw-gap-4 tw-fixed">
      <CoreAlert
        v-for="toastMessage in alertQueue"
        :key="toastMessage.alertId"
        :alertId="toastMessage.alertId"
        :status="toastMessage.status"
        :message="toastMessage.message"
        :type="AlertType.TOAST" />
    </transition-group>
  </portal>
</template>

<style scoped>
.toasts-wrapper {
  top: 3rem;
  right: 3rem;
  z-index: 1041; /* Workaroud to show alerts over CoreModal */
}
</style>
